import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleStack32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSpeechBubbleStack32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.762 18v-2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-5.858l-.582.564-2.798 2.712zM19 18h-5.048l-3.646 3.534c-.952.922-2.544.248-2.544-1.077V18H7a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4m-6 5q-.464-.001-.899-.101L14 21h4.858l.581.564 2.8 2.712V21H25a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2V9a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4h-.762v2.457c0 1.325-1.592 2-2.544 1.077L18.048 23z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleStack32);
